<template>
  <v-layout v-if="accountData.current_sessions" wrap row class="px-1">
    <v-flex>
      <div class="card overflow-hidden position-relative">
        <single-chart
          :title="common.handlePaymentModelName(accountData.payment_model)"
          :number="common.numberWithCommas(accountData.current_sessions)"
        />
      </div>
    </v-flex>
    <v-flex v-if="accountData.messages">
      <div class="card overflow-hidden position-relative">
        <single-chart
          title="Messages"
          :number="common.numberWithCommas(accountData.messages)"
        />
      </div>
    </v-flex>
    <v-flex  v-if="accountData.transferred_to_agent">
      <div class="card overflow-hidden position-relative">
        <single-chart
          title="Escalations"
          :number="common.numberWithCommas(accountData.transferred_to_agent)"
        />
      </div>
    </v-flex>
    <v-flex v-if="accountData.last_day">
      <div class="card overflow-hidden position-relative">
        <single-chart
          title="Conversations Last 24H"
          :number="common.numberWithCommas(accountData.last_day)"
        />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import singleChart from '@/components/botAnalytics/singleChart/index'
import common from '@/utils/analytics/common'
export default {
  name: 'accountNumbers',
  components: {
    singleChart
  },
  props: {
    accountData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      common
    }
  }
}
</script>

<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
